module.exports = __webpack_public_path__ + "img/lunbo01_01.48a4fb93.png";